import type {
  OrgSummaryDto,
  TaskStatusOverviewDto,
  OverdueTaskDto,
  ProjectHealthDto,
  TeamMemberWorkloadDto,
  TaskDistributionDto,
  TimeAnalysisDto,
  AllTaskItemDto,
  PagedResult,
} from '../types';

export const mockOrgSummary: OrgSummaryDto = {
  totalTasks: 15,
  totalProjects: 3,
  completedTasks: 4,
  completedTasksPercentage: 26.67,
  inProgressTasks: 3,
  overdueTasks: 7,
  overdueTasksPercentage: 46.67,
  averageEfficiencyPercentage: 57.4,
};

export const mockTaskStatusOverview: TaskStatusOverviewDto = {
  todoTasks: 8,
  inProgressTasks: 3,
  doneTasks: 4,
  totalEstimatedHours: 65.5,
  totalTrackedHours: 29.75,
  urgentTasksCount: 2,
};

export const mockOverdueTasks: PagedResult<OverdueTaskDto> = {
  items: [
    {
      id: '123456789',
      title: 'Integración con CRM externo',
      projectId: '987654321',
      projectName: 'Plataforma de Análisis',
      projectColor: '#6366f1',
      assigneeId: '111222333',
      assigneeName: 'Ana García',
      assigneeAvatarUrl: null,
      priority: 4,
      dueDate: '2026-06-01T00:00:00Z',
      delayDays: 15,
    },
    {
      id: '123456790',
      title: 'Revisar diseño de pantalla de onboarding',
      projectId: '987654322',
      projectName: 'Rediseño Web',
      projectColor: '#10b981',
      assigneeId: '111222334',
      assigneeName: 'Carlos Ruiz',
      assigneeAvatarUrl: null,
      priority: 3,
      dueDate: '2026-06-05T00:00:00Z',
      delayDays: 11,
    },
    {
      id: '123456791',
      title: 'Corrección de bug en autenticación',
      projectId: '987654321',
      projectName: 'Plataforma de Análisis',
      projectColor: '#6366f1',
      assigneeId: '111222335',
      assigneeName: 'Laura Martínez',
      assigneeAvatarUrl: null,
      priority: 4,
      dueDate: '2026-06-08T00:00:00Z',
      delayDays: 8,
    },
  ],
  page: 1,
  pageSize: 10,
  totalCount: 7,
  totalPages: 1,
  hasNextPage: false,
  hasPreviousPage: false,
};

export const mockProjectHealth: ProjectHealthDto[] = [
  {
    projectId: '987654321',
    projectName: 'Plataforma de Análisis',
    projectColor: '#6366f1',
    projectStatus: 'Active',
    progressPercentage: 42.86,
    totalTasks: 7,
    doneTasks: 3,
    inProgressTasks: 2,
    todoTasks: 1,
    overdueTasks: 4,
    efficiencyPercentage: 57.4,
    totalEstimatedHours: 34.33,
    totalTrackedHours: 19.75,
  },
  {
    projectId: '987654322',
    projectName: 'Rediseño Web',
    projectColor: '#10b981',
    projectStatus: 'Active',
    progressPercentage: 25.0,
    totalTasks: 4,
    doneTasks: 1,
    inProgressTasks: 1,
    todoTasks: 2,
    overdueTasks: 2,
    efficiencyPercentage: 62.0,
    totalEstimatedHours: 18.0,
    totalTrackedHours: 6.5,
  },
  {
    projectId: '987654323',
    projectName: 'App Móvil',
    projectColor: '#f59e0b',
    projectStatus: 'OnHold',
    progressPercentage: 0.0,
    totalTasks: 4,
    doneTasks: 0,
    inProgressTasks: 0,
    todoTasks: 4,
    overdueTasks: 1,
    efficiencyPercentage: 0.0,
    totalEstimatedHours: 13.17,
    totalTrackedHours: 0.0,
  },
];

export const mockTeamWorkload: TeamMemberWorkloadDto[] = [
  {
    userId: '111222333',
    userName: 'Ana García',
    userAvatarUrl: null,
    totalTasks: 5,
    doneTasks: 2,
    inProgressTasks: 2,
    todoTasks: 1,
    overdueTasks: 3,
    efficiencyPercentage: 65.0,
    totalEstimatedHours: 20.0,
    totalTrackedHours: 13.0,
  },
  {
    userId: '111222334',
    userName: 'Carlos Ruiz',
    userAvatarUrl: null,
    totalTasks: 4,
    doneTasks: 1,
    inProgressTasks: 1,
    todoTasks: 2,
    overdueTasks: 2,
    efficiencyPercentage: 55.0,
    totalEstimatedHours: 18.0,
    totalTrackedHours: 7.0,
  },
  {
    userId: '111222335',
    userName: 'Laura Martínez',
    userAvatarUrl: null,
    totalTasks: 3,
    doneTasks: 1,
    inProgressTasks: 0,
    todoTasks: 2,
    overdueTasks: 1,
    efficiencyPercentage: 48.0,
    totalEstimatedHours: 12.5,
    totalTrackedHours: 5.25,
  },
];

export const mockTaskDistribution: TaskDistributionDto = {
  byStatus: [
    { label: 'Done', count: 4, percentage: 26.67 },
    { label: 'InProgress', count: 3, percentage: 20.0 },
    { label: 'Todo', count: 8, percentage: 53.33 },
  ],
  byPriority: [
    { label: 'None', count: 1, percentage: 6.67 },
    { label: 'Low', count: 3, percentage: 20.0 },
    { label: 'Medium', count: 5, percentage: 33.33 },
    { label: 'High', count: 4, percentage: 26.67 },
    { label: 'Urgent', count: 2, percentage: 13.33 },
  ],
  byProject: [
    {
      projectId: '987654321',
      projectName: 'Plataforma de Análisis',
      projectColor: '#6366f1',
      count: 7,
      percentage: 46.67,
    },
    {
      projectId: '987654322',
      projectName: 'Rediseño Web',
      projectColor: '#10b981',
      count: 4,
      percentage: 26.67,
    },
    {
      projectId: '987654323',
      projectName: 'App Móvil',
      projectColor: '#f59e0b',
      count: 4,
      percentage: 26.67,
    },
  ],
};

export const mockTimeAnalysis: TimeAnalysisDto = {
  weeklyTrend: [
    { weekStart: '2026-03-30', trackedHours: 10.5 },
    { weekStart: '2026-04-07', trackedHours: 12.5 },
    { weekStart: '2026-04-14', trackedHours: 18.25 },
    { weekStart: '2026-04-21', trackedHours: 8.0 },
    { weekStart: '2026-04-28', trackedHours: 14.0 },
    { weekStart: '2026-05-05', trackedHours: 22.5 },
    { weekStart: '2026-05-12', trackedHours: 16.75 },
    { weekStart: '2026-05-19', trackedHours: 20.0 },
    { weekStart: '2026-05-26', trackedHours: 11.5 },
    { weekStart: '2026-06-02', trackedHours: 18.0 },
    { weekStart: '2026-06-09', trackedHours: 15.25 },
    { weekStart: '2026-06-16', trackedHours: 9.75 },
  ],
  byProject: [
    {
      projectId: '987654321',
      projectName: 'Plataforma de Análisis',
      projectColor: '#6366f1',
      estimatedHours: 34.33,
      trackedHours: 19.75,
      efficiencyPercentage: 57.54,
    },
    {
      projectId: '987654322',
      projectName: 'Rediseño Web',
      projectColor: '#10b981',
      estimatedHours: 18.0,
      trackedHours: 10.0,
      efficiencyPercentage: 55.56,
    },
    {
      projectId: '987654323',
      projectName: 'App Móvil',
      projectColor: '#f59e0b',
      estimatedHours: 13.17,
      trackedHours: 0.0,
      efficiencyPercentage: 0.0,
    },
  ],
  totalEstimatedHours: 65.5,
  totalTrackedHours: 29.75,
  overallEfficiencyPercentage: 45.42,
};

export const mockAllTasks: PagedResult<AllTaskItemDto> = {
  items: [
    {
      taskId: '123456789',
      title: 'Integración con CRM externo',
      projectId: '987654321',
      projectName: 'Plataforma de Análisis',
      projectColor: '#6366f1',
      assigneeId: '111222333',
      assigneeName: 'Ana García',
      assigneeAvatarUrl: null,
      statusType: 'InProgress',
      statusName: 'En progreso',
      priority: 4,
      dueDate: '2026-06-01T00:00:00Z',
      estimatedHours: 7.0,
      trackedHours: 0.5,
      efficiencyPercentage: 7.14,
      isOverdue: true,
    },
    {
      taskId: '123456790',
      title: 'Diseño de pantalla de onboarding',
      projectId: '987654322',
      projectName: 'Rediseño Web',
      projectColor: '#10b981',
      assigneeId: '111222334',
      assigneeName: 'Carlos Ruiz',
      assigneeAvatarUrl: null,
      statusType: 'Todo',
      statusName: 'Por hacer',
      priority: 3,
      dueDate: '2026-06-20T00:00:00Z',
      estimatedHours: 5.0,
      trackedHours: 0.0,
      efficiencyPercentage: 0.0,
      isOverdue: false,
    },
    {
      taskId: '123456791',
      title: 'Configuración de CI/CD pipeline',
      projectId: '987654321',
      projectName: 'Plataforma de Análisis',
      projectColor: '#6366f1',
      assigneeId: '111222335',
      assigneeName: 'Laura Martínez',
      assigneeAvatarUrl: null,
      statusType: 'Done',
      statusName: 'Completada',
      priority: 2,
      dueDate: '2026-06-10T00:00:00Z',
      estimatedHours: 4.0,
      trackedHours: 3.5,
      efficiencyPercentage: 87.5,
      isOverdue: false,
    },
  ],
  page: 1,
  pageSize: 20,
  totalCount: 15,
  totalPages: 1,
  hasNextPage: false,
  hasPreviousPage: false,
};
